import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectAuthAccess } from 'src/features/auth/store';

export const RootRedirect: React.FC = () => {
	const accessToken = useSelector(selectAuthAccess);

	return <Navigate to={accessToken ? '/dashboard' : '/signin'} replace />;
};
